import React, {useEffect} from 'react'
import { useShared } from '../../hooks/useShared'
import AMenu from '../../components/partials/AMenu';
import MainSection from '../../components/sections/MainSection';


const TABLE_HEAD = ["#", "اسم زون", 'تلفون', 'ايميل', "ادرس", 'ملاحظات', 'تاريخ ايجاد', 'اقدامات'];
const breadcrumbs = [{ name: 'بودجه', link: '/budgets' }]

const menuData = [
  { flag: "Edit", name: 'ايرايش', icon: 'create-outline', roles: [1, 2,24] },
  { flag: "Delete", name: 'حذف', icon: 'trash-outline', roles: [1,2,24] },
]


const searchInputFields = [
  { label: 'اسم زون', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: 'md:col-span-3' },
  { label: 'تلفون', name: 'phone', type: 'text', roles: [1], icon: 'call-outline', className: 'md:col-span-3', },
  { label: 'ايميل', name: 'email', type: 'text', roles: [1], icon: 'at-outline', className: 'md:col-span-3' },
  { label: 'ادرس', name: 'address', type: 'text', roles: [1], icon: 'book-outline', className: 'md:col-span-3' },
];


const newModelInputFields = [
  { label: 'اسم زون', name: 'name', type: 'text', roles: [1], icon: 'text-outline', className: '', required: 'The name is requieed', isStyle: false },
  { label: 'تلفون', name: 'phone', type: 'number', roles: [1], icon: 'call-outline', className: '', required: 'The phone address is requieed', isStyle: false },
  { label: 'ايميل', name: 'email', type: 'email', roles: [1], icon: 'at-outline', className: '', required: false, isStyle: false },
  { label: 'ادرس', name: 'address', type: 'text', roles: [1], icon: 'text-outline', className: '', required: false, isStyle: false },
  { label: 'ملاحظات', name: 'description', type: 'textarea', roles: [1], icon: 'book-outline', className: '', required: false, isStyle: false },

];

const csvHeaders = [
  { label: "#", key: "index" },
  { label: "اسم زون", key: "name" },
  { label: "تليفون", key: "phone" },
  { label: "ايمیل", key: "email" },
  { label: "ادرس", key: "address" },
  { label: "ملاحظات", key: "to_date" },
  { label: "تاريخ ايحاد", key: "date" },
  { label: "ايجاد کننده", key: "creator_id" },
];


export default function Zones() {



  const { com, setModel,models, auth,navigate, setShowNewModelDialog, setShowViewDialog,showDeleteDialog, setShowDeleteDialog } = useShared();


    useEffect(() => {
      if (!auth.hasRole([1,2,24])) {
          return navigate("/db/notAllowed")
      }
    }, [])


  const handleMenu = (model, flag = false) => {
    console.log("handleMenu ", model, flag);

    if (flag === 'delete') {
      setModel(model)
      setShowDeleteDialog(!showDeleteDialog)
    }
    if (flag === 'edit') {
      setModel(model)
      setShowNewModelDialog(true)
    }
    if (flag === 'view') {
      setModel(model)
      setShowViewDialog(true)
    }
  };



  const handleViewDialog = (obj) => {
    return [
      { l: 'نام', v: obj?.name },
      { l: 'تليفون', v: obj?.phone },
      { l: 'ايمیل', v: obj?.email },
      { l: 'ادرس', v: obj?.address },
      { l: 'ملاحظات', v: obj?.description },
      { l: 'تاريخ ايجاد', v: com.ddmmyyhhmmA(obj?.updated_at) },
    ]
  }

  const getTableData = () => {
    const data = models?.data
    return <tbody className=''>
      {data?.map((r, i) => {
        return (<tr key={r?.id}>
              <td >{models?.from + i}</td>
              <td className='!p-1'> {r?.name} </td>
              <td >{r?.phone}</td>
              <td >{r?.email}</td>
              <td >{r?.address} </td>
              <td>{r?.description}</td>

              <td style={{ direction: 'ltr' }}>{com.dateConvert(r?.created_at, false, true)}
                <p>{r?.user?.full_name}</p>
              </td>
              <td >
                <AMenu v={{ handleMenu: (row, flag) => handleMenu(row, flag), row: r, menuData }} />
              </td>
            </tr>)
      })}
    </tbody>
  }

  return (
      <MainSection v={{
        handleViewDialog,
        newModelInputFields,
        searchInputFields,
        TABLE_HEAD,
        breadcrumbs,
        tableData: getTableData(),
        modelName: { name: 'zones', af: 'زون‌ها' },
        mUrl: { delete: 'zones', create: 'zones', getAll: 'zonesAdvanceSearch' },
        addNewItemTitle: "زون جديد",
        tableTitle: 'لیست زون‌ها',
        newModelDialogClassName: "h-fit",
        csv: { csvHeaders, show: true }
      }} />
  )

}
